import { ServiceCatalogCategory, ServiceCatalogTranslations } from '@fcom/dapi';
import { FinnairServiceCatalogItemV3, Medium } from '@fcom/dapi/api/models';
import { CmsContent, CmsContentType, CmsImageData, HtmlString, PageViewType } from '@fcom/core-api/interfaces';
import { mapValues } from '@fcom/core/utils';

const asServiceCatalogTranslations = (translations: Record<string, unknown>): ServiceCatalogTranslations => {
  return {
    ...translations,
    title: (translations?.title as string) || '',
  };
};

const asCmsImageData = (medium: Medium): CmsImageData & CmsContent => {
  return medium
    ? {
        ...medium,
        customPlacement: null,
        subjectTaxonomyTags: [],
        contentId: medium.contentId ?? null,
        contentType: CmsContentType[medium.contentType as keyof typeof CmsContentType],
        teaserText: medium.teaserText as HtmlString,
        viewTypeName: PageViewType[medium.viewTypeName as keyof typeof PageViewType],
        alt: medium.alt ?? null,
        responsiveImageLinksData: {
          landscape_ratio16x9: {
            ...medium.responsiveImageLinksData?.landscape_ratio16x9,
          },
          landscape_ratio4x3: {
            ...medium.responsiveImageLinksData?.landscape_ratio4x3,
          },
          landscape_ratio21x9: {
            ...medium.responsiveImageLinksData?.landscape_ratio21x9,
          },
          portrait_ratio1x1: {
            ...medium.responsiveImageLinksData?.portrait_ratio1x1,
          },
        },
      }
    : undefined;
};

export const asServiceCatalogCategory = (category: FinnairServiceCatalogItemV3): ServiceCatalogCategory => ({
  ...category,
  translations: asServiceCatalogTranslations(category.translations),
  media: asCmsImageData(category.media),
  services: mapValues(category.services, (servicePerTraveler) =>
    mapValues(servicePerTraveler, (servicesForTraveler) =>
      servicesForTraveler.map((service) => ({
        ...service,
        translations: asServiceCatalogTranslations(service.translations),
        media: asCmsImageData(service.media),
        category: category.category,
      }))
    )
  ),
});
